import Vue from 'vue'
import Main from '@/views/Main.vue'
import router from '@/router'
import '@/plugins/iview.js'
import '@/plugins/htmlDecode.js'
import i18n from '@/plugins/i18n.js'
import store from '@/store'
import logger from '@/assets/log'
import { hasPermission, hasPlatformPermission, hasUserGroup } from "./store/Permission";
import {debounce} from "./store/Util";
import UtilTool from './store/Util';
import cordovaModel from "./model/CordovaModel";
import versionModel from "./model/VersionModel";
const log = logger("app");

log.info("app run");

import MaterialFilterBar from "@/components/MaterialFilterBar"
import echarts from 'echarts' //引入echarts

Vue.use(UtilTool);

Vue.config.productionTip = false

Vue.prototype.hasPermission = hasPermission;
Vue.prototype.hasPlatformPermission = hasPlatformPermission;
Vue.prototype.debounce = debounce;
Vue.prototype.hasUserGroup = hasUserGroup;
// Vue.prototype.hasPermission = ()=>{return true};

cordovaModel.init();

Vue.prototype.isCordova = cordovaModel.isCordova;
Vue.prototype.isIOS = cordovaModel.isIOS;
Vue.prototype.isAndroid = cordovaModel.isAndroid;
Vue.prototype.isMobile = ()=>{
    return cordovaModel.isIOS() || cordovaModel.isAndroid()
};
Vue.prototype.isPortrait = cordovaModel.isPortrait;

Vue.prototype.echarts = echarts;

// 根据profile加载定制的标题
Vue.prototype.tt = function(name, options) {
    var p = store.state.config.profile;
    var theName = name+"_"+p;
    console.log(theName);
    var title = this.$t(theName, options);
    if(title == theName) {
        return this.$t(name, options);
    }
    return title;
};

Vue.prototype.containsInvaildChar = function(value) {
    var ret = /[<>"&]/.test(value);
    if(ret) {
        this.$Message.error('内容不能包含<>"&等字符');
    }
    return ret;
}

Vue.component("MaterialFilterBar", MaterialFilterBar);

versionModel.checkVersionUpdate();
store.dispatch("config/load")

new Vue({
    router,
    store,
    i18n,
    render: h => h(Main)
}).$mount('#main');

// 开发模式、弹出未捕获异常
if(Vue.config.devtools) {
    window.onerror = function(msg/*,  src, line, col, error */) {
        alert(msg)
    };
}

Date.prototype.format = function(fmt) { 
    var o = { 
       "M+" : this.getMonth()+1,                 //月份 
       "d+" : this.getDate(),                    //日 
       "H+" : this.getHours(),                   //小时 
       "m+" : this.getMinutes(),                 //分 
       "s+" : this.getSeconds(),                 //秒 
       "q+" : Math.floor((this.getMonth()+3)/3), //季度 
       "S"  : this.getMilliseconds()             //毫秒 
   }; 
   if(/(y+)/.test(fmt)) {
           fmt=fmt.replace(RegExp.$1, (this.getFullYear()+"").substr(4 - RegExp.$1.length)); 
   }
    for(var k in o) {
       if(new RegExp("("+ k +")").test(fmt)){
            fmt = fmt.replace(RegExp.$1, (RegExp.$1.length==1) ? (o[k]) : (("00"+ o[k]).substr((""+ o[k]).length)));
        }
    }
   return fmt; 
}

export default i18n;